import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'content-list',
  templateUrl: './content-list.component.html',
  styleUrls: ['./content-list.component.css']
})
export class ContentListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
